import React from 'react';
import { NavLink } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import moment from 'moment';
import { DRAWER_WIDTH } from './MainContainer';

const UniversalFooter = ({ instashellSetup, isMobile }) => {

    const generateFooterColumns = () => {
        const contentsArr = [];
        contentsArr.push(
            <Grid item xs={12} sm={3} key="version">
                <div className="small-label primary-font">Application version {instashellSetup.applicationVersion}</div>
            </Grid>
        );
        instashellSetup.footerItemsArr.forEach((col, colIndex) => {
            const subContentsArr = [];
            col.contents.forEach((item, itemIndex) => {
                if (item?.type === 'link') {
                    subContentsArr.push(
                        <NavLink to={item?.path} key={itemIndex}>
                            <div className="small-label primary-font">{item?.label}</div>
                        </NavLink>
                    );
                } else if (item?.type === 'component') {
                    subContentsArr.push(
                        <div key={itemIndex}>{item.component}</div>
                    );
                }
            });
            contentsArr.push(
                <Grid item xs={12} sm={3} key={colIndex}>
                    <div className="medium-label primary-font" style={{ marginBottom: '8px' }}>{col?.title}</div>
                    {subContentsArr}
                </Grid>
            );
        });
        contentsArr.push(
            <Grid item xs={12} key="copyright">
                <div className="small-label primary-font" style={{ marginTop: '24px' }}>
                    © Matthew Farmer {moment().year()}
                </div>
            </Grid>
        );
        return contentsArr;
    };

    return (
        <div
            id="universalFooter"
            style={{
                width: '100%',
                position: 'relative',
                padding: '32px 32px 32px',
                paddingLeft: isMobile ? '32px' : `${DRAWER_WIDTH + 32}px`,
                boxSizing: 'border-box',
            }}
        >
            <Grid container spacing={3}>
                {generateFooterColumns()}
            </Grid>
        </div>
    );
};

export default UniversalFooter;
